import GooglePayProcess from 'app/components/OrderPayment/GooglePay/GooglePayProcess';
import React from 'react';

const GooglePayPayment = () => {
  return <GooglePayProcess />;
};

export default GooglePayPayment;
